import {Rows} from "Components/Layout/Table";

const UserTable: Rows = {
    id: {
        placeholders: [
            {
                element: 'p',
                size: 1
            }
        ]
    },
    name: {
        placeholders: [
            {
                element: 'p',
                size: [2, 2],
            }
        ],
    },
    email: {
        placeholders: [
            {
                element: 'p',
                size: [3],
            }
        ]
    },
    group: {
        field: 'name',
        i18nPlaceholder: 'app.ungrouped',
        placeholders: [
            {
                element: 'p',
                size: [2],
            }
        ]
    },
    actions: {
        className: 'actions',
        sortable: false,
        placeholders: [
            {
                element: 'a',
                size: 2,
            },
        ]
    },
};

export default UserTable